import { connect } from 'react-redux';
import View from './CloseButtonView';
import { setOpen, setWhatIfsBody } from '../WhatIfsActions';

const mapDispatchToProps = dispatch => ({
  onClose: clientId => () => {
    dispatch(setOpen(clientId, false));
    dispatch(setWhatIfsBody(null));
  },
});

export default connect(null, mapDispatchToProps)(View);
